module.exports = __webpack_public_path__ + "img/KINDERNINO-08.26004aa2.png";